import { ErrorResponse, Timestamp, TuettuKieli } from '@lemon/core/model/common'
import { KnowYourCustomer, LemonaidAsiakkaanKuukausihinta } from './kayttaja'

export type SopimusLiitetyyppi = 'lisapalveluhinnasto' | 'palveluerittely' | 'yleiset-ehdot' | 'henkilotietojen-kasittely' | 'tal2023'
export const SOPIMUS_LIITETYYPIT: SopimusLiitetyyppi[] = ['lisapalveluhinnasto', 'palveluerittely', 'yleiset-ehdot', 'henkilotietojen-kasittely', 'tal2023']
export const SOPIMUS_LIITE_NIMET: Record<SopimusLiitetyyppi, string> = {
  lisapalveluhinnasto: 'sopimus-ja-ehdot.liite-lisapalveluhinnasto',
  palveluerittely: 'sopimus-ja-ehdot.liite-palveluerittely',
  'yleiset-ehdot': 'sopimus-ja-ehdot.liite-yleiset-ehdot',
  'henkilotietojen-kasittely': 'sopimus-ja-ehdot.liite-henkilotietojen-kasittely',
  tal2023: 'sopimus-ja-ehdot.liite-tal2023',
}

export interface SopimusLiitteenVersio {
  avain: string
  pvm: Timestamp
  uid: string
}

export interface Sopimus {
  avain: string
  pvm: Timestamp
  uid: string
  /** @deprecated Will be removed after pre-made PDF logic is fully rolled out to all customers. */
  textInDiffLangs?: TextInDiffLanguages
  liitteet?: { [liite in SopimusLiitetyyppi]: SopimusLiitteenVersio }
}
export interface TextInDiffLanguages {
  [key: string]: string
}
export interface SopimusLemonatorTyojono {
  pvm: Timestamp
}

export interface SopimuksenHyvaksyntaFirestoressa {
  /**
   * Sama avain kuin sopimuksella.
   */
  avain: string
  /**
   * Asiakkaan avain, collection group queryä varten
   */
  asiakasAvain: string
  /**
   * kayttajaAvain, collection group queryä varten
   */
  kayttajaAvain: string
  /**
   * Milloin hyväksyntä tehtiin.
   */
  aika: Timestamp
}
export interface HetuTallennusRequest {
  hetu: string
}

export interface HyvaksytynSopimuksenTekstiJaAvainRequest {
  kieli: TuettuKieli
}
export interface HyvaksytynSopimuksenTekstiJaAvainResponse extends ErrorResponse {
  sopimusAvain: string
  sopimusPdf: string
}

export interface SopimuksenHintaJaTekstiRequest {
  kieli: TuettuKieli
}

export interface SopimuksenHintaJaTekstiResponse extends ErrorResponse {
  hinta: LemonaidAsiakkaanKuukausihinta
  sopimusAvain: string
  asiakkaanSopimusversionAvain?: string
  sopimusTeksti: string
}

export interface HetuTallennusResponse extends ErrorResponse<'lemon-unknown' | 'no-hetu' | 'invalid-hetu' | 'no-asiakas' | 'no-kayttaja' | 'unknown-error'> {}
export interface SopimuksenHyvaksynnanRequest {
  asiakkaanSopimusversionAvain: string
  kieli: TuettuKieli
}

export interface SopimuksenHyvaksynnanResponse extends ErrorResponse<'no-sopimusavain' | 'not-authorized' | 'no-kayttaja' | 'no-asiakas' | 'unknown-error'> {}

export interface SopimusTaukoHalutaanLopettaaRequest {}

export interface SopimusTaukoHalutaanLopettaaResponse extends ErrorResponse<'unknown-error'> {}

export interface SopimuksenHyvaksynnanHistoria {
  asiakasAvain: string
  kayttajaAvain: string
  pvm: Timestamp
  sopimusAvain: string
  asiakkaanSopimusversionAvain?: string
  kieli: TuettuKieli
  liiteAvaimet?: Partial<Record<SopimusLiitetyyppi, string>>
}
export interface KnowYourCustomerSaveRequest {
  kyc: KnowYourCustomer
}

export interface KnowYourCustomerSaveResponse extends ErrorResponse<'kyc-undefined' | 'no-kayttaja' | 'not-authorized' | 'unknown-error'> {}

export interface SopimuksenAllekirjoitanutRequest {
  sopimusAvain: string
}
export interface SopimuksenAllekirjoittajaJaAika {
  nimi: string
  /** Format yyMMddhhmmss */
  aika: number
}

export interface SopimuksenAllekirjoitanutResponse extends ErrorResponse {
  allekirjoitanut: SopimuksenAllekirjoittajaJaAika[]
}

export interface MaksuominaisuusPyyntoWorkQueue {
  asiakasAvain: string
  kayttajaAvain: string
  startedAt: Timestamp
  uudelleenyrityksia: number
}

export interface SopimusLopetaTaukoWorkQueue {
  asiakasAvain: string
  kayttajaAvain: string
  startedAt: Timestamp
  uudelleenyrityksia: number
}

export interface Palvelukuvaus {
  avain: string
  pvm: Timestamp
  uid: string
  textInDiffLangs: TextInDiffLanguages
}

export interface SopimusPdfRequest {
  versio: 'uusin' | string
  kieli: TuettuKieli
}

export interface SopimusPdfResponse extends ErrorResponse {
  base64String?: string
}

export interface PalvelukuvauksenPdfRequest {
  kieli: TuettuKieli
}

export interface PalvelukuvauksenPdfResponse extends ErrorResponse {
  base64String?: string
}

export const LAST_SOPIMUS_VERSION_WITH_TEXT_IN_FIRESTORE = 'IbHkeam2b5GBg9ofaBNl'

export interface SopimuksenPdfTemplateLatausPyynto {
  sopimusAvain: string
  kieli: TuettuKieli
  pdfBase64: string
}

export interface SopimuksenPdfTemplateLatausVastaus extends ErrorResponse<'invalid-request' | 'missing-fields' | 'unknown-error'> {
  missingFields?: string[] // Only included if e === 'missing-fields'
}

export interface SopimuksenTemplateUrlRequest {
  sopimusAvain: string
}
export interface SopimuksenTemplateUrlResponse {
  base64Fi?: string
  base64En?: string
  e?: string
}

export type SopimusLiiteMap<T> = Partial<Record<SopimusLiitetyyppi, T>>

export interface SopimusLiiteLatausPyynto {
  liitetyyppi: SopimusLiitetyyppi
  pdfBase64Fi: string
  pdfBase64En: string
}
export interface SopimusLiiteLatausVastaus extends ErrorResponse<'invalid-request' | 'unknown-error'> {}

export interface SopimusLiiteHakutulos {
  liitetyyppi: SopimusLiitetyyppi
  nimi: string
  versionAvain?: string
  base64Fi?: string
  base64En?: string
}
export interface SopimusLiitteetHakuVastaus extends ErrorResponse {
  liitteet?: SopimusLiiteHakutulos[]
}

export interface SopimusLiiteAsiakkaanHakuPyynto {
  liitetyyppi: SopimusLiitetyyppi
  kieli: TuettuKieli
}
export interface SopimusLiiteAsiakkaanHakuVastaus extends ErrorResponse {
  base64String?: string
}
